import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import TextButton from 'components/TextButton';
import { eventName, notaFiscalAction } from 'components/ApplicationInsights/eventNames';
import { Visibility } from 'components/Visibility';

import iconDownload from 'img/arrow-download.svg';

import { DownloadInLotTypes } from '../interface';
import { EnumCTEsTabs } from 'models/CTEs';

interface OptionsDownloadInLotOrdersProps {
  handleSendRequestDownloadInLot: (downloadType: number) => void;
}

const OptionsDownloadInLotCte: React.FC<OptionsDownloadInLotOrdersProps> = (props) => {

  const { handleSendRequestDownloadInLot } = props;

  const currentTabId = useSelector((state: RootState) => state.currentTab?.currentNameTab);

  const isCteListing = currentTabId === EnumCTEsTabs.LISTAGEM_CTES;

  return (
    <Visibility visible={isCteListing}>
      <TextButton
        title="CTE"
        onSendRequest={() => handleSendRequestDownloadInLot(DownloadInLotTypes.ELECTRONIC_BILL_LADING)}
        loading={false}
        trackName={eventName.DOWNLOAD_CTE}
        trackAction={notaFiscalAction.CTE_NOTAFISCAL_PDF}
        img={iconDownload}
        className="mr-3" />
      <TextButton
        title="XML"
        onSendRequest={() => handleSendRequestDownloadInLot(DownloadInLotTypes.ELECTRONIC_BILL_LADING_XML)}
        loading={false}
        trackName={eventName.XML_CTE}
        trackAction={notaFiscalAction.CTE_NOTAFISCAL_XML}
        img={iconDownload}
        className="mr-3" />
    </Visibility>
  );
};

export default OptionsDownloadInLotCte;